(ns machtfit.startpage.global-search)

(def cross-area-search-flag
  :dev_3793_cross_area_search)

(defn cross-area-search-url [db search-string area]
  (when (get-in db [:django-feature-flags cross-area-search-flag])
    (let [term (or search-string "")]
      (if (= area :all)
        (str "/suche/?" (js/URLSearchParams. #js {:q term}))
        (str "/angebote-new/?" (js/URLSearchParams. #js {:keyword term
                                                         :area (name area)}))))))
